export const LANGUAGE = {
  EN: 1,
};

export const API_TIMEOUT = 60000; // 60 seconds for API requests (increased for large projects)
export const FILE_UPLOAD_TIMEOUT = 300000; // 5 minutes for file uploads

export const NOTIFICATION_DURATION = 4;

export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: "HD_ACCESS_TOKEN",
  REFRESH_TOKEN: "HD_REFRESH_TOKEN",
  USER_INFO: "HD_USER_INFO"
};

export const LISTING_DATA = {
  FIRST_PAGE: 1,
  PAGE_SIZE: 10,
  PAGE_SIZE_MAX_SIZE: 9999,
};

export const SORT = {
  ASC: 'ascend',
  DESC: 'descend',
};

export const SEARCH_TYPING_INTERVAL = 700;